import { Box, Table, TableBody, TableHead, TableRow } from "@mui/material";
import { ReadonlyVec3, vec3 } from "gl-matrix";
import { useTranslation } from "react-i18next";

import { useUom } from "features/uom/hooks/useUom";
import { UnitType } from "features/uom/spec";
import { convertAndFormat } from "features/uom/utils";

import { TableCell } from "./tableCell";

export function MeasurementTable({ start, end }: { start: ReadonlyVec3; end: ReadonlyVec3 }) {
    const { t } = useTranslation();
    const delta = vec3.sub(vec3.create(), end, start);
    const uom = useUom();

    return (
        <Table size="small" padding="none">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            X
                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            Y
                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Box display="inline-block" ml={1}>
                            Z
                        </Box>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell>{t("start")}</TableCell>
                    {start.map((v, idx) => (
                        <TableCell key={idx} align="right">
                            {convertAndFormat(uom, v, UnitType.length, { decimals: 3 })}
                        </TableCell>
                    ))}
                </TableRow>
                <TableRow>
                    <TableCell>{t("end")}</TableCell>
                    {end.map((v, idx) => (
                        <TableCell key={idx} align="right">
                            {convertAndFormat(uom, v, UnitType.length, { decimals: 3 })}
                        </TableCell>
                    ))}
                </TableRow>
                <TableRow>
                    <TableCell bold>{t("difference")}</TableCell>
                    <TableCell bold align="right">
                        {convertAndFormat(uom, Math.abs(delta[0]), UnitType.length, { decimals: 3 })}
                    </TableCell>
                    <TableCell bold align="right">
                        {convertAndFormat(uom, Math.abs(delta[1]), UnitType.length, { decimals: 3 })}
                    </TableCell>
                    <TableCell bold align="right">
                        {convertAndFormat(uom, Math.abs(delta[2]), UnitType.length, { decimals: 3 })}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}
